import Modal from "components/HOCS/Modal";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectAccountDetailsModal,
  selectDeviceSettingsModal,
  setAccountDetailsModal,
  setDeviceSettingsModal,
} from "slices/extraOptionsSlice";
import AccountDetails from "./AccountDetails";
import DeviceSettings from "./DeviceSettings/DeviceSettings";

const PersonalSettings = () => {
  const dispatch = useDispatch();
  const accountDetailsModal = useSelector(selectAccountDetailsModal);
  const deviceSettingsModal = useSelector(selectDeviceSettingsModal);

  return (
    <>
      {!accountDetailsModal ? null : (
        <Modal
          growth={false}
          noBackDropClick={false}
          lightBackDrop={false}
          header={"Account Details"}
          content={<AccountDetails />}
          onDismiss={() => {
            dispatch(setAccountDetailsModal(false));
          }}
        />
      )}
      {!deviceSettingsModal ? null : (
        <Modal
          growth={false}
          noBackDropClick={false}
          lightBackDrop={false}
          header={"Device Settings"}
          content={<DeviceSettings />}
          onDismiss={() => {
            dispatch(setDeviceSettingsModal(false));
          }}
        />
      )}
    </>
  );
};

export default PersonalSettings;
